import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchDirective } from './switch.directive';
import { SwitchLabelDirective } from './switch-label/switch-label.directive';
import { SwitchComponent } from './switch.component';

@NgModule({
  declarations: [SwitchDirective, SwitchLabelDirective, SwitchComponent],
  imports: [CommonModule],
  exports: [SwitchDirective, SwitchLabelDirective, SwitchComponent],
})
export class SwitchModule {}
